import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Collapse } from "reactstrap";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import classname from "classnames";
import "./navbar.css";

// i18n
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

const Navbar = props => {
  const [openDropdown, setOpenDropdown] = useState(null); // <--- FIX: unified toggle
  const [user, setUser] = useState(null);
  const [extra, setextra] = useState(false)



  useEffect(() => {
    let authUser = JSON.parse(localStorage.getItem("authUser"));
    setUser(authUser);
  }, []);


  useEffect(() => {
    const handleStorageChange = () => {
      const updatedUser = JSON.parse(localStorage.getItem("authUser"));
      setUser(updatedUser);
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);


  useEffect(() => {
    const pathName = process.env.PUBLIC_URL + props.router.location.pathname;

    let matchingMenuItem = null;
    const ul = document.getElementById("navigation");
    const items = ul?.getElementsByTagName("a") || [];

    removeActivation(items);

    for (let i = 0; i < items.length; i++) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) activateParentDropdown(matchingMenuItem);
  });

  /** Remove all active classes */
  const removeActivation = items => {
    for (let i = 0; i < items.length; i++) {
      items[i].classList.remove("active");
      items[i].parentElement?.classList.remove("active");
    }
  };

  /** Activate nested parents */
  function activateParentDropdown(item) {
    item.classList.add("active");
    let parent = item.parentElement;

    while (parent) {
      parent.classList.add("active");
      parent = parent.parentElement;
    }
  }

  /** Toggle dropdown */
  const toggleDropdown = name => {
    setOpenDropdown(openDropdown === name ? null : name);
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="topnav">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >

            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav">
                {/* SUPERADMIN */}
                {user?.role === "superadmin" && (
                  <>
                    {/* Dashboard */}
                    <li className="nav-item">
                      <Link className="nav-link" to="/admin-dashboard">
                        <i className="ti-dashboard"></i> {props.t("Dashboard")}
                      </Link>
                    </li>
                    {/* Dashboard */}
                    <li className="nav-item">
                      <Link className="nav-link" to="/admin-stats">
                        <i className="ti-dashboard"></i> {props.t("Stats")}
                      </Link>
                    </li>

                    {/* Zero Payments */}
                    {/* <li className="nav-item dropdown">
                      <Link
                        to="#"
                        onClick={() => toggleDropdown("zero")}
                        className="nav-link dropdown-toggle"
                      >
                        <i className="ti-dashboard"></i>
                        {props.t("Zero Payments")}
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: openDropdown === "zero"
                        })}
                      >
                        <Link to="/zero-course-payments" className="dropdown-item">
                          {props.t("Zero Course Payments")}
                        </Link>
                      </div>
                    </li> */}
                  </>
                )}

                {/* DEVELOPER */}
                {user?.role === "developer" && (
                  <>
                    <li className="nav-item">
                      <Link className="nav-link" to="/dashboard">
                        <i className="ti-dashboard"></i> {props.t("Dashboard")}
                      </Link>
                    </li>

                    {/* Stats */}
                    <li className="nav-item dropdown">
                      <Link
                        to="#"
                        onClick={() => toggleDropdown("stats")}
                        className="nav-link dropdown-toggle"
                      >
                        <i className="ti-email"></i> {props.t("Statistics")}
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: openDropdown === "stats"
                        })}
                      >

                        <Link
                          to="/payment-statistics"
                          className="dropdown-item"
                        >
                          {props.t("Payments Statistics")}
                        </Link>
                        <Link
                          to="/course-wise-seats-statistics"
                          className="dropdown-item"
                        >
                          {props.t("Seats Statistics")}
                        </Link>

                      </div>
                    </li>


                    {/* Registrations */}
                    <li className="nav-item dropdown">
                      <Link
                        to="#"
                        onClick={() => toggleDropdown("registrations")}
                        className="nav-link dropdown-toggle"
                      >
                        <i className="ti-email"></i> {props.t("Registrations")}
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: openDropdown === "registrations"
                        })}
                      >
                        <Link
                          to="/course-program-names-list"
                          className="dropdown-item"
                        >
                          {props.t("Program Names List")}
                        </Link>
                        <Link
                          to="/course-registrations-list"
                          className="dropdown-item"
                        >
                          {props.t("Course Registrations List")}
                        </Link>
                      </div>
                    </li>

                    {/* Discounts */}
                    <li className="nav-item dropdown">
                      <Link
                        to="#"
                        onClick={() => toggleDropdown("discounts")}
                        className="nav-link dropdown-toggle"
                      >
                        <i className="ti-support"></i> {props.t("Discounts")}
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: openDropdown === "discounts"
                        })}
                      >
                        <Link to="/course-discounts-list" className="dropdown-item">
                          {props.t("Discounts List")}
                        </Link>
                      </div>
                    </li>

                    {/* Refunds */}
                    <li className="nav-item dropdown">
                      <Link
                        to="#"
                        onClick={() => toggleDropdown("refunds")}
                        className="nav-link dropdown-toggle"
                      >
                        <i className="ti-receipt"></i> {props.t("Refunds")}
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: openDropdown === "refunds"
                        })}
                      >
                        <Link to="/course-refunds-list" className="dropdown-item">
                          {props.t("Refunds List")}
                        </Link>
                        <Link to="/refund-approval-list" className="dropdown-item">
                          {props.t("Refunds Approval List")}
                        </Link>
                      </div>
                    </li>

                    {/* Payments */}
                    <li className="nav-item dropdown">
                      <Link
                        to="#"
                        onClick={() => toggleDropdown("payments")}
                        className="nav-link dropdown-toggle"
                      >
                        <i className="ti-dashboard"></i> {props.t("Payments")}
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: openDropdown === "payments"
                        })}
                      >
                        {/* <Link to="/zero-course-payments" className="dropdown-item">
                          {props.t("Zero Course Payments")}
                        </Link> */}
                        <Link
                          to="/bulk-upload-payment-status"
                          className="dropdown-item"
                        >
                          {props.t("Payment Status Bulk Upload")}
                        </Link>
                        {/* <Link to="/payment-receipt" className="dropdown-item">
                          {props.t("Payment Receipt")}
                        </Link> */}
                      </div>
                    </li>

                    {/* Tech Panel */}
                    <li className="nav-item dropdown">
                      <Link
                        to="#"
                        onClick={() => toggleDropdown("techPanel")}
                        className="nav-link dropdown-toggle"
                      >
                        <i className="ti-support"></i> {props.t("Tech Panel")}
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: openDropdown === "techPanel"
                        })}
                      >
                        <Link to="/tech-panel-payments" className="dropdown-item">
                          {props.t("Tech Panel")}
                        </Link>
                        <Link to="/payment-analytics" className="dropdown-item">
                          {props.t("Payment Analytics")}
                        </Link>
                        <Link to="/payment-analytics-dashboard" className="dropdown-item">
                          {props.t("Payment Analytics Dashboard")}
                        </Link>
                        <Link to="/codeforge-payment-analytics" className="dropdown-item">
                          {props.t("CodeForge Payment Analytics")}
                        </Link>
                      </div>

                    </li>


                    {/* Student Registrations */}
                    <li className="nav-item dropdown">
                      <Link
                        to="#"
                        onClick={() => toggleDropdown("studentReg")}
                        className="nav-link dropdown-toggle"
                      >
                        <i className="ti-support"></i>{" "}
                        {props.t("Student Registrations")}
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: openDropdown === "studentReg"
                        })}
                      >
                        <Link
                          to="/add-student-registration-bulk"
                          className="dropdown-item"
                        >
                          {props.t("Bulk upload Registrations")}
                        </Link>
                        <Link
                          to="/student-registrations-list"
                          className="dropdown-item"
                        >
                          {props.t("Total Registrations")}
                        </Link>
                        <Link
                          to="/student-registrations-course-wise-list"
                          className="dropdown-item"
                        >
                          {props.t("Course Wise Registrations")}
                        </Link>
                        <Link
                          to="/swap-student-course"
                          className="dropdown-item"
                        >
                          {props.t("Swap Student Course")}
                        </Link>
                        <Link
                          to="/swap-student-course-after-paid"
                          className="dropdown-item"
                        >
                          {props.t("Swap Paid Student Technology")}
                        </Link>
                        <Link
                          to="/drop-student-registration-bulk"
                          className="dropdown-item"
                        >
                          {props.t("Drop Student Registrations")}
                        </Link>
                      </div>
                    </li>


                    {/* certifications */}
                    {/* <li className="nav-item dropdown">
                      <Link
                        to="#"
                        onClick={() => toggleDropdown("cert")}

                        className="nav-link dropdown-toggle arrow-none"
                      >
                        <i className="ti-support"></i>
                        {props.t("Certifications")}
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: openDropdown === "cert"
                        })}
                      >
                        <Link to="/certifications-registration-list" className="dropdown-item">
                          {props.t("Certifications")}
                        </Link>
                      </div>
                    </li> */}

                  </>
                )}
                {/* {user?.role === "trainer" || user?.role === "admin" && (
                  <>
                    <li className="nav-item dropdown">
                      <Link
                        to="#"
                        onClick={() => toggleDropdown("techPanel")}
                        className="nav-link dropdown-toggle"
                      >
                        <i className="ti-support"></i> {props.t("Tech Panel")}
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: openDropdown === "techPanel"
                        })}
                      >
                        <Link to="/tech-panel-payments" className="dropdown-item">
                          {props.t("Tech Panel")}
                        </Link>
                      </div>
                    </li>
                  </>
                )} */}

                {user?.role === "admin" && (
                  <>
                    {/* Tech Panel */}
                    {/* <li className="nav-item dropdown">
                      <Link
                        to="#"
                        onClick={() => toggleDropdown("techPanel")}
                        className="nav-link dropdown-toggle"
                      >
                        <i className="ti-support"></i> {props.t("Tech Panel")}
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: openDropdown === "techPanel"
                        })}
                      >
                        <Link to="/tech-panel-payments" className="dropdown-item">
                          {props.t("Tech Panel")}
                        </Link>
                      </div>
                    </li> */}

                    <li className="nav-item dropdown">
                      <Link
                        to="#"
                        onClick={() => toggleDropdown("refunds")}
                        className="nav-link dropdown-toggle"
                      >
                        <i className="ti-receipt"></i> {props.t("Refunds")}
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: openDropdown === "refunds"
                        })}
                      >
                        <Link to="/course-refunds-list" className="dropdown-item">
                          {props.t("Refunds List")}
                        </Link>
                      </div>
                    </li>
                  </>
                )
                }


                {/* CASHIER */}
                {user?.role === "cashier" && (
                  <>
                    <li className="nav-item">
                      <Link className="nav-link" to="/dashboard">
                        <i className="ti-dashboard"></i> {props.t("Dashboard")}
                      </Link>
                    </li>

                    <li className="nav-item dropdown">
                      <Link
                        to="#"
                        onClick={() => toggleDropdown("cashierPayments")}
                        className="nav-link dropdown-toggle"
                      >
                        <i className="ti-dashboard"></i> {props.t("Payments")}
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: openDropdown === "cashierPayments"
                        })}
                      >
                        <Link to="/course-payments" className="dropdown-item">
                          {props.t("Course Payments")}
                        </Link>
                        <Link to="/payment-receipt" className="dropdown-item">
                          {props.t("Payment Receipt")}
                        </Link>
                      </div>
                    </li>
                    <li className="nav-item dropdown">
                      <Link
                        to="#"
                        onClick={() => toggleDropdown("cashierRefunds")}
                        className="nav-link dropdown-toggle"
                      >
                        <i className="ti-receipt"></i> {props.t("Refunds")}
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: openDropdown === "cashierRefunds"
                        })}
                      >
                        <Link to="/refund-approval-list" className="dropdown-item">
                          {props.t("Refunds Approval List")}
                        </Link>
                         <Link to="/refund-receipt-by-roll-no" className="dropdown-item">
                          {props.t("Refund Receipt")}
                        </Link>
                      </div>
                    </li>
                  </>
                )}

                {/* ACCOUNTS */}
                {user?.role === "accounts" && (
                  <>
                    <li className="nav-item">
                      <Link className="nav-link" to="/dashboard">
                        <i className="ti-dashboard"></i> {props.t("Dashboard")}
                      </Link>
                    </li>
                      <li className="nav-item dropdown">
                      <Link
                        to="#"
                        onClick={() => toggleDropdown("discounts")}
                        className="nav-link dropdown-toggle"
                      >
                        <i className="ti-support"></i> {props.t("Discounts")}
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: openDropdown === "discounts"
                        })}
                      >
                        <Link to="/course-discounts-list" className="dropdown-item">
                          {props.t("Discounts List")}
                        </Link>
                      </div>
                    </li>


                    <li className="nav-item">
                      <Link className="nav-link" to="/payment-statistics">
                        <i className="ti-dashboard"></i> {props.t("Payments Statistics")}
                      </Link>
                    </li>
                  </>
                )}
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  );
};

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout;
  return { leftMenu };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar))
);

